// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DeleteFilledSvg from "@ant-design/icons-svg/es/asn/DeleteFilled";
import AntdIcon from '../components/AntdIcon';

var DeleteFilled = function DeleteFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DeleteFilledSvg
  }));
};

DeleteFilled.displayName = 'DeleteFilled';
export default React.forwardRef(DeleteFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/DeleteFilled.js
// module id = 919
// module chunks = 0